<template>
    <div class="modal-card" style="width: 100%">
        <header class="modal-card-head">
            <p class="modal-card-title">
                Verificare formular <strong>{{ currentManualFormId }}</strong>
            </p>
            <button type="button" class="delete" @click="$emit('close')" />
        </header>
        <section class="modal-card-body">
            <div class="columns">
                <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false"></b-loading>
                <div class="column is-6">
                    <div class="has-text-left is-fixed">
                        <div
                            class="title has-text-weight-semibold is-size-6 has-text-weight-bold is-flex is-align-content-center is-align-items-center"
                        >
                            <div>
                                <b-icon class="mr-3 has-text-grey-lighter" icon="account-details-outline"> </b-icon>
                            </div>
                            <div>Date contribuabil</div>
                        </div>
                        <div class="columns">
                            <div class="column">
                                <b-field>
                                    <b-input
                                        size="is-small"
                                        disabled
                                        placeholder="Nume"
                                        v-model.trim="form.nume"
                                        minlength="1"
                                    ></b-input>
                                </b-field>
                            </div>
                            <div class="column">
                                <b-field>
                                    <b-input
                                        size="is-small"
                                        disabled
                                        placeholder="Prenume"
                                        v-model.trim="form.prenume"
                                        minlength="1"
                                    ></b-input>
                                </b-field>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column">
                                <b-field>
                                    <b-input
                                        size="is-small"
                                        disabled
                                        placeholder="Initiala tata"
                                        v-model.trim="form.initiala"
                                        minlength="1"
                                    ></b-input>
                                </b-field>
                            </div>
                            <div class="column">
                                <b-field>
                                    <b-input
                                        disabled
                                        size="is-small"
                                        class="is-fulllength"
                                        placeholder="CNP"
                                        v-model.trim="form.cnp"
                                        minlength="1"
                                    ></b-input>
                                </b-field>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column">
                                <b-field>
                                    <b-input
                                        disabled
                                        size="is-small"
                                        placeholder="Email"
                                        type="email"
                                        v-model.trim="form.email"
                                        minlength="1"
                                    ></b-input>
                                </b-field>
                            </div>
                            <div class="column">
                                <b-field>
                                    <b-input
                                        disabled
                                        size="is-small"
                                        placeholder="Telefon"
                                        v-model.trim="form.telefon"
                                        minlength="1"
                                    ></b-input>
                                </b-field>
                            </div>
                        </div>

                        <div
                            class="subtitle has-text-weight-semibold is-size-6 has-text-weight-bold is-flex is-align-content-center is-align-items-center"
                        >
                            <div>
                                <b-icon class="mr-3 has-text-grey-lighter" icon="map-marker-radius-outline"> </b-icon>
                            </div>
                            <div>Adresa</div>
                        </div>
                        <div class="columns">
                            <div class="column">
                                <b-field
                                    ><b-input
                                        disabled
                                        size="is-small"
                                        placeholder="Judet"
                                        v-model.trim="form.forms_address.judet"
                                        minlength="1"
                                    ></b-input>
                                </b-field>
                            </div>
                            <div class="column">
                                <b-field
                                    ><b-input
                                        disabled
                                        size="is-small"
                                        placeholder="Localitate"
                                        v-model.trim="form.forms_address.localitate"
                                        minlength="1"
                                    ></b-input>
                                </b-field>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column">
                                <b-field>
                                    <b-input
                                        disabled
                                        size="is-small"
                                        placeholder="Strada"
                                        v-model.trim="form.forms_address.strada"
                                        minlength="1"
                                    ></b-input>
                                </b-field>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column">
                                <b-field>
                                    <b-input
                                        disabled
                                        size="is-small"
                                        placeholder="Numar"
                                        v-model.trim="form.forms_address.numar"
                                        minlength="1"
                                    ></b-input>
                                </b-field>
                            </div>
                            <div class="column">
                                <b-field>
                                    <b-input
                                        disabled
                                        size="is-small"
                                        placeholder="Bloc"
                                        v-model.trim="form.forms_address.bloc"
                                        minlength="1"
                                    ></b-input>
                                </b-field>
                            </div>
                            <div class="column">
                                <b-field>
                                    <b-input
                                        disabled
                                        size="is-small"
                                        placeholder="Scara"
                                        v-model.trim="form.forms_address.scara"
                                        minlength="1"
                                    ></b-input>
                                </b-field>
                            </div>
                            <div class="column">
                                <b-field>
                                    <b-input
                                        disabled
                                        size="is-small"
                                        placeholder="Etaj"
                                        v-model.trim="form.forms_address.etaj"
                                        minlength="1"
                                    ></b-input>
                                </b-field>
                            </div>
                            <div class="column">
                                <b-field>
                                    <b-input
                                        disabled
                                        size="is-small"
                                        placeholder="Apartament"
                                        v-model.trim="form.forms_address.apartament"
                                        minlength="1"
                                    ></b-input>
                                </b-field>
                            </div>
                        </div>
                        <hr />
                        <div class="columns is-desktop is-align-content-center is-align-items-center">
                            <div class="column is-3">
                                <div
                                    class="subtitle has-text-weight-semibold is-size-6 has-text-weight-bold is-flex is-align-content-center is-align-items-center"
                                >
                                    <div>
                                        <b-icon class="mr-3 has-text-grey-lighter" icon="calendar-month-outline">
                                        </b-icon>
                                    </div>
                                    <div>Perioada</div>
                                </div>
                            </div>
                            <div class="column is-radio is-3">
                                <b-field>
                                    <b-radio-button
                                        :disabled="true"
                                        class="period-form"
                                        type="is-success"
                                        size="is-small"
                                        name="perioada"
                                        checked
                                    >
                                        {{ form.perioada == 1 ? '1 An' : '2 Ani' }}
                                    </b-radio-button>
                                </b-field>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="divider" :class="{ 'is-vertical': !isMobile }">Preview</div>

                <div class="column is-5">
                    <div class="preview-pdf" v-if="fileIsPDF">
                        <pdf :src="filePreview"></pdf>
                    </div>
                    <div class="preview-image" v-else>
                        <b-image v-if="filePreview != null" :src="filePreview" responsive></b-image>
                    </div>
                </div>
            </div>
        </section>
        <footer class="modal-card-foot">
            <b-button
                :disabled="isApproveLoading || isNextLoading || isDeleteLoading"
                type="is-info"
                @click="$emit('close')"
                >Inchide</b-button
            >
            <b-button
                :disabled="isApproveLoading || isNextLoading || isDeleteLoading"
                :loading="isApproveLoading"
                type="is-success"
                @click="approve"
                >Aproba</b-button
            >
            <b-button
                :disabled="isApproveLoading || isNextLoading || isDeleteLoading"
                :loading="isNextLoading"
                type="is-warning"
                @click="next"
                >Pending</b-button
            >
            <b-button
                :disabled="isApproveLoading || isNextLoading || isDeleteLoading"
                :loading="isDeleteLoading"
                type="is-danger"
                @click="remove"
                >Sterge</b-button
            >
        </footer>
    </div>
</template>

<script>
import * as toast from '@/utils/toast';
import * as dialogs from '@/utils/dialog';

import { mapGetters } from 'vuex';
import pdf from 'vue-pdf';
import { _base64ToArrayBuffer } from '@/utils/functions';

export default {
    components: {
        pdf,
    },
    data: () => ({
        isLoading: false,
        isApproveLoading: false,
        isNextLoading: false,
        isDeleteLoading: false,
        filePreview: null,
    }),
    methods: {
        async approve() {
            this.isApproveLoading = true;
            try {
                await this.$store.dispatch('admin/ApproveForm', this.currentManualFormId);
                toast.success('Formular aprobat');
                this.$emit('next');
            } catch (err) {
                toast.error('Eroare la aprobarea formularului');
            } finally {
                this.isApproveLoading = false;
            }
        },
        async remove() {
            const confirmation = await dialogs.confirm(
                'Confirmare',
                `Sterg formularul ${this.currentManualFormId}?`,
                'Confirm',
                'is-warning'
            );
            if (!confirmation.result) return false;
            this.isDeleteLoading = true;
            try {
                await this.$store.dispatch('admin/DeleteForm230', this.currentManualFormId);
                toast.success('Formular sters');
                this.$emit('next');
            } catch (err) {
                toast.error('Eroare la stergerea formularului');
            } finally {
                this.isDeleteLoading = false;
            }
        },
        next() {
            this.isNextLoading = true;
            setTimeout(() => (this.$emit('next'), (this.isNextLoading = false)), 500);
        },
        async getManualFormData() {
            this.isLoading = true;
            try {
                await this.$store.dispatch('admin/GetManualFormData');
                if (!this.fileIsPDF) {
                    this.filePreview = `data:${this.form.semnatura.mime};base64,${this.form.semnatura.data}`;
                } else {
                    this.filePreview = _base64ToArrayBuffer(this.form.semnatura.data);
                }
            } catch (err) {
                toast.error('Eroare la preluarea datelor formularului');
            } finally {
                this.isLoading = false;
            }
        },
    },
    computed: {
        ...mapGetters({
            form: 'admin/currentManualForm',
            currentManualFormId: 'admin/currentManualFormId',
        }),
        fileIsPDF() {
            return this.form.semnatura != null && this.form.semnatura.extension === 'pdf';
        },
        isMobile() {
            return this.$isMobile();
        },
    },
    watch: {
        currentManualFormId() {
            return this.getManualFormData();
        },
    },
    created() {
        return this.getManualFormData();
    },
};
</script>

<style lang="scss" scoped>
.main-container {
    padding: 0;
    position: relative;
}

.font-14 {
    font-size: 0.9rem;
    font-weight: 500;
}

.period-form {
    &:not(:last-child) {
        margin-right: 20px !important;
    }

    .radio {
        border-radius: 10px !important;
    }
}

.is-size-4 {
    font-size: 1.5rem !important;
}

hr {
    background-color: #dbdbdb;
}

.info {
    display: table;
    margin: 0 auto;
    margin-top: 50px;
    padding: 40px;
    opacity: 0.9;

    .info-text {
        font-size: 0.9rem;
        padding-top: 5px;
    }
}

.on-mobile-left {
    border-radius: 6px 6px 0px 0px;
}
.on-mobile-right .box {
    border-radius: 0px 0px 6px 6px;
}

.form-title {
    font-size: 1.8rem;
}

.text-with-border {
    border: 1px solid;
    background-color: white;
    border-color: #dbdbdb;
    border-radius: 4px;
    color: #363636;
    height: 3.5em;
    font-size: 0.9rem;
    line-height: 1.5;
    padding-bottom: calc(0.5em - 1px);
    padding-left: calc(0.75em - 1px);
    padding-right: calc(0.75em - 1px);
    padding-top: calc(0.5em - 1px);
}

::v-deep .on-mobile input:disabled {
    -webkit-appearance: none;
    color: #7a7a7a !important;
    background-color: #f5f5f5bf;
    -webkit-text-fill-color: #7a7a7a !important;
    -webkit-opacity: 1 !important;
    opacity: 1 !important;
}

.overlay-invalid {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    align-items: center;
    display: flex;
    justify-content: center;
    overflow: hidden;
    z-index: 999;

    .ov-background {
        bottom: 0;
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
        background: #7f7f7f;
        background: rgb(255 255 255 / 78%);
    }

    .ov-text {
        padding: 50px;
        background-color: #296c9e;
        z-index: 120;
        color: #fff;
        border-radius: 6px;
        position: fixed;
        top: 20em;
        box-shadow: 6px 6px 5px rgb(0 0 0 / 33%);
    }
}

::v-deep .is-radio .radio {
    color: #363636 !important;
}

.is-fixed {
    position: -webkit-sticky; /* Safari */
    position: sticky;
    top: 0;
}

.formular-230 {
    height: 3.2em !important;
    font-size: 0.85rem !important;
}
</style>
